export default function AreasHeroSection() {
  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-20">
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-yellow-500/10 border border-yellow-500/30 rounded-full px-6 py-2 mb-6">
            <i className="ri-map-pin-line text-yellow-500"></i>
            <span className="text-yellow-500 font-semibold text-sm">Service Coverage</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-black mb-6 leading-tight">
            Areas We Cover in <span className="text-yellow-500">Essex</span>
          </h1>
          <p className="text-xl text-gray-300 mb-8 leading-relaxed">
            Professional bollard installation services across all major towns and cities in Essex. 
            We provide telescopic, fold down, and electric bollard solutions for residential and commercial properties throughout the county.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="#areas" className="bg-yellow-500 text-black px-8 py-3 rounded-lg font-semibold hover:bg-yellow-400 transition-colors whitespace-nowrap cursor-pointer">
              View All Areas
            </a>
            <a href="tel:+447834858178" className="bg-white/10 backdrop-blur-sm text-white border border-white/20 px-8 py-3 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer">
              Call Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
